// Shared option lists for the delivery blacklist editor. Mirrors the backend
// Notification_Blacklist_Rule choices.

export const DELIVERY_TYPES = [
    { value: 'email', label: 'Email' },
    { value: 'sms', label: 'SMS' },
    { value: 'whatsapp', label: 'WhatsApp' },
    { value: 'airbnb', label: 'Airbnb' },
];

export const MATCH_TYPES = [
    { value: 'exact', label: 'Exact match' },
    { value: 'substring', label: 'Substring match' },
    { value: 'regex', label: 'Regular expression' },
    { value: 'user', label: 'User' },
    { value: 'ota', label: 'OTA' },
    { value: 'reseller', label: 'Reseller (booking source)' },
    { value: 'tag', label: 'Tag condition' },
    { value: 'sender', label: 'Sender (who sent the message)' },
];

export const deliveryTypeLabel = (v) => (DELIVERY_TYPES.find((t) => t.value === v) || {}).label || v;
export const matchTypeLabel = (v) => (MATCH_TYPES.find((t) => t.value === v) || {}).label || v;

export const RESOURCE = 'blacklist_rule';

// Mirrors Notification_Blacklist_Rule.REDIRECT_MAX_INBOXES (CP-8150).
export const MAX_REDIRECT_INBOXES = 5;

// What a match does (CP-8482). Mirrors Notification_Blacklist_Rule.ACTIONS.
export const ACTIONS = [
    { value: 'block', label: 'Block (optionally redirect)' },
    { value: 'cc', label: 'Deliver and Cc' },
];
export const actionLabel = (v) => (ACTIONS.find((a) => a.value === v) || ACTIONS[0]).label;

// Mirrors Notification_Blacklist_Rule.CC_MAX_INBOXES.
export const MAX_CC_INBOXES = 5;

// How several conditions combine (CP-8268). Mirrors
// Notification_Blacklist_Rule.CONDITION_MATCH_MODES.
export const CONDITION_MATCH_MODES = [
    { value: 'all', label: 'Match all (AND)' },
    { value: 'any', label: 'Match any (OR)' },
];

// Mirrors apiv2.lib.blacklist.MAX_CONDITIONS.
export const MAX_CONDITIONS = 8;
